import { render, staticRenderFns } from "./Teaser.vue?vue&type=template&id=93c3e3b4"
import script from "./Teaser.vue?vue&type=script&lang=js"
export * from "./Teaser.vue?vue&type=script&lang=js"
import style0 from "./Teaser.vue?vue&type=style&index=0&id=93c3e3b4&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports